import React from 'react';
import { ShoppingCart, Wrench, TrendingUp, Users, Star, Clock } from 'lucide-react';
import { StatCard } from '../../components/vendor/StatCard';
export function Dashboard() {
  // Simulated data for the dashboard
  const stats = [{
    title: 'Total Orders',
    value: '124',
    icon: <ShoppingCart size={24} className="text-primary" data-id="element-1616" />,
    change: {
      value: '12%',
      positive: true
    }
  }, {
    title: 'Active Services',
    value: '8',
    icon: <Wrench size={24} className="text-primary" data-id="element-1617" />
  }, {
    title: 'Monthly Revenue',
    value: 'MYR 8,320',
    icon: <TrendingUp size={24} className="text-primary" data-id="element-1618" />,
    change: {
      value: '8%',
      positive: true
    }
  }, {
    title: 'Total Customers',
    value: '47',
    icon: <Users size={24} className="text-primary" data-id="element-1619" />,
    change: {
      value: '5%',
      positive: true
    }
  }];
  // Simulated recent orders
  const recentOrders = [{
    id: 'ORD-1234',
    customer: 'Ahmad Bin Abdullah',
    service: 'Bathroom Waterproofing',
    date: '2023-10-15',
    status: 'completed',
    amount: 'MYR 850.00'
  }, {
    id: 'ORD-1233',
    customer: 'Lim Wei Ling',
    service: 'Living Room Painting',
    date: '2023-10-14',
    status: 'in-progress',
    amount: 'MYR 1,200.00'
  }, {
    id: 'ORD-1232',
    customer: 'Rajesh Kumar',
    service: 'Door Repair',
    date: '2023-10-12',
    status: 'confirmed',
    amount: 'MYR 250.00'
  }, {
    id: 'ORD-1231',
    customer: 'Siti Nurhayati',
    service: 'Kitchen Waterproofing',
    date: '2023-10-10',
    status: 'pending',
    amount: 'MYR 750.00'
  }];
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'confirmed':
        return 'bg-blue-100 text-blue-800';
      case 'in-progress':
        return 'bg-purple-100 text-purple-800';
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'cancelled':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div data-id="element-1620">
      <div className="mb-6" data-id="element-1621">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1622">Dashboard</h1>
        <p className="text-gray-600 mt-1" data-id="element-1623">
          Overview of your business performance
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-1624">
        {stats.map((stat, index) => <StatCard key={index} title={stat.title} value={stat.value} icon={stat.icon} change={stat.change} data-id="element-1625" />)}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-1626">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-1627">
          <div className="flex items-center justify-between mb-4" data-id="element-1628">
            <h2 className="text-lg font-medium text-gray-900" data-id="element-1629">Recent Orders</h2>
            <a href="/vendor/orders" className="text-sm text-primary font-medium hover:underline" data-id="element-1630">
              View all
            </a>
          </div>
          <div className="overflow-x-auto" data-id="element-1631">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-1632">
              <thead className="bg-gray-50" data-id="element-1633">
                <tr data-id="element-1634">
                  <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1635">
                    Order ID
                  </th>
                  <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1636">
                    Customer
                  </th>
                  <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1637">
                    Status
                  </th>
                  <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1638">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1639">
                {recentOrders.map(order => <tr key={order.id} className="hover:bg-gray-50" data-id="element-1640">
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1641">
                      {order.id}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-1642">
                      {order.customer}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap" data-id="element-1643">
                      <span className={`px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full ${getStatusColor(order.status)}`} data-id="element-1644">
                        {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                      </span>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-1645">
                      {order.amount}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-6" data-id="element-1646">
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-1647">
            <div className="flex items-center mb-4" data-id="element-1648">
              <Star size={20} className="text-yellow-500 mr-2" data-id="element-1649" />
              <h2 className="text-lg font-medium text-gray-900" data-id="element-1650">
                Performance Rating
              </h2>
            </div>
            <div className="flex items-center justify-center py-4" data-id="element-1651">
              <div className="text-center" data-id="element-1652">
                <div className="text-5xl font-bold text-gray-900" data-id="element-1653">4.8</div>
                <div className="mt-1 text-sm text-gray-600" data-id="element-1654">Average Rating</div>
                <div className="mt-4 flex items-center justify-center" data-id="element-1655">
                  {[...Array(5)].map((_, i) => <Star key={i} size={24} className={i < 4 ? 'text-yellow-500 fill-current' : i === 4 ? 'text-yellow-500 fill-current opacity-80' : 'text-gray-300'} data-id="element-1656" />)}
                </div>
                <div className="mt-2 text-sm text-gray-600" data-id="element-1657">
                  Based on 36 reviews
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-1658">
            <div className="flex items-center mb-4" data-id="element-1659">
              <Clock size={20} className="text-primary mr-2" data-id="element-1660" />
              <h2 className="text-lg font-medium text-gray-900" data-id="element-1661">
                Upcoming Appointments
              </h2>
            </div>
            <div className="space-y-4" data-id="element-1662">
              {[{
              customer: 'Tan Mei Ling',
              service: 'Bedroom Painting',
              date: 'Oct 18, 2023',
              time: '10:00 AM'
            }, {
              customer: 'David Wong',
              service: 'Bathroom Waterproofing',
              date: 'Oct 19, 2023',
              time: '2:30 PM'
            }].map((appointment, index) => <div key={index} className="flex items-start p-3 border border-gray-200 rounded-md" data-id="element-1663">
                  <div className="flex-shrink-0 h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center mr-3" data-id="element-1664">
                    <span className="text-primary font-medium" data-id="element-1665">
                      {appointment.customer.charAt(0)}
                    </span>
                  </div>
                  <div data-id="element-1666">
                    <p className="font-medium text-gray-900" data-id="element-1667">
                      {appointment.customer}
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-1668">
                      {appointment.service}
                    </p>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-1669">
                      {appointment.date} at {appointment.time}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}